import {
	GridColumnMenuFilter,
	GridColumnMenuCheckboxFilter,
	GridColumnMenuProps,
	GridColumnProps,
} from "@progress/kendo-react-grid";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import CellPopover, { CellPopoverWithText } from "ui/grid/DescriptionCell";
import { t } from "i18next";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import React from "react";
import { calculateFieldStats } from "utils/statUtils";
import { formatNorwegianNumber } from "utils/helper";
import { PageAccessByMenu } from "interface/user";

export const salesStatisticsGridColumnItems = (props: {
	ref?: React.RefObject<HTMLDivElement>;
	data: any[];
	pageAccess: PageAccessByMenu | null;
}): GridColumnProps[] => {
	const allColumns: GridColumnProps[] = [
		{
			field: "",
			width: "30px",
			cells: {
				data: () => <td></td>,
				headerCell: () => (
					<td>
						<span ref={props.ref}>
							<img
								src={`/icon/${ICON_NAMES.EllispsisVeritcal}.svg`}
								alt="Column dropdown"
								style={{ height: 20, width: 20, cursor: "pointer" }}
							/>
						</span>
					</td>
				),
			},
		},

		{
			field: "salesDateTime",
			title: t("SalesDate"),
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.salesDateTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
				footerCell: (props) => <td className={""}>{t("Total")}</td>,
				groupFooter: (props) => {
					const _props = props as any;

					return (
						<CellPopoverWithText
							{..._props}
							text={t("Total") + " " + props.dataItem.value}
						/>
						// <td
						// 	className={" no-border td-bold"}
						// >
						// 	{t("Total") + " " + props.dataItem.value}
						// </td>
					);
				},
			},
			width: "100px",
			hidden: false,
		},
		//{
		//	field: "soldBy",
		//	title: t("SoldBy"),
		//	cell: (props) => <CellPopover {...props} />,
		//	width: "150px",
		//	hidden: false,
		//},
		{
			field: "firstCatchDate",
			title: t("FirstCatchDateShort"),
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.firstCatchDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
			width: "110px",
			hidden: true,
		},
		{
			field: "lastCatchDate",
			title: t("LastCatchDateShort"),
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.lastCatchDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
			width: "110px",
			hidden: true,
		},
		{
			field: "contractNoteNumber",
			title: t("ContractNoteNumber"),
			width: "140px",
			hidden: true,
		},
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "90px",
			hidden: true,
		},
		{
			field: "specieCode",
			title: t("SpeciesCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			width: "130px",
			hidden: true,
		},
		{
			field: "specieDescription",
			title: t("Species"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: "150px",
			hidden: false,
		},
		{
			field: "productDescription",
			title: t("Product"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },
			hidden: false,
			width: 200,
		},
		{
			field: "productConditionCode",
			title: t("Condition"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "productConditionDescription",
			title: t("ConditionDescription"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "productPreservationType",
			title: t("PreservationType"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		{
			field: "productPackagingCode",
			title: t("Packaging"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "productPackagingDescription",
			title: t("PackagingDescription"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "fishingGearCode",
			title: t("FishingGearCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },

			hidden: true,
		},
		{
			field: "fishingGearDescription",
			title: t("FishingGear"),
			cells: { data: (props) => <CellPopover {...props} /> },

			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		{
			field: "catchAreaCode",
			title: t("CatchAreaCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "catchAreaDescription",
			title: t("CatchArea"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "catchAreaZone",
			title: t("CatchAreaZone"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "catchAreaFDZone",
			title: t("CatchAreaFDZone"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "catchAreaNSzone",
			title: t("CatchAreaNS64zone"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "catchAreaNS64zone",
			title: t("CatchAreaNS62zone"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "landingNoteNumber",
			title: t("LandingNoteNumber"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			width: "150px",
			hidden: true,
		},
		{
			field: "deliveryDateTime",
			title: t("DeliveryDate"),
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.deliveryDateTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
			width: "140px",
			hidden: true,
		},
		{
			field: "terminalCode",
			title: t("TerminalCode"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "terminalDescription",
			title: t("Terminal"),
			cells: { data: (props) => <CellPopover {...props} /> },

			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "vesselRegistrationNumber",
			title: t("VesselRegistrationId"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "vesselDescription",
			title: t("VesselName"),
			cells: { data: (props) => <CellPopover {...props} /> },
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		{
			field: "vesselLenght",
			title: t("VesselLength"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "vesselOwnerBusinessRegistrationNumber",
			title: t("VesselOwnerRegistrationNumber"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			cells: { data: (props) => <CellPopover {...props} /> },

			hidden: true,
		},
		{
			field: "vesselOwnerDescription",
			title: t("VesselOwner"),
			cells: { data: (props) => <CellPopover {...props} /> },

			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "vesselOwnerGroupDescription",
			title: t("VesselOwnerGroup"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "buyerId",
			title: t("BuyerId"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "buyerDescription",
			title: t("Buyer"),
			cells: { data: (props) => <CellPopover {...props} /> },

			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		{
			field: "year",
			title: t("Year"),
			filter: "numeric",
			filterTitle: "Year",
			hidden: true,
		},
		{
			field: "period",
			title: t("Period"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "month",
			title: t("Month"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "week",
			title: t("Week"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "day",
			title: t("Day"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "salesForm",
			title: t("SaleForm"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "msc",
			title: t("MSC"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: false,
		},
		{
			field: "turnNumber",
			title: t("Turnummer"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "qualityDescription",
			title: t("Quality"),
			columnMenu: (prop) => (
				<ColumnMenuCheckboxFilter {...prop} data={props.data} />
			),
			hidden: true,
		},
		{
			field: "grossWeight",
			title: t("Weight"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			className: `no-border`,
			headerClassName: "header-menu-numerical",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				footerCell: (prop) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					let data = props.dataItem.aggregates[props.field as any];

					return (
						<td className={CLASSNAME.TableNumeric}>
							<div
								style={{ marginTop: "20px" }}
								className="no-border td-bold"
							>{`Min: ${formatNorwegianNumber(data.min, minDecimal, maxDecimal)}
									 Avg: ${formatNorwegianNumber(
											data.average,
											minDecimal,
											maxDecimal,
										)} Max:  ${formatNorwegianNumber(
											data.max,
											minDecimal,
											maxDecimal,
										)}`}</div>
						</td>
					);
				},
			},
			hidden: false,
		},
		{
			field: "roundWeight",
			title: t("RoundWeight"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			headerClassName: "header-menu-numerical",

			cells: {
				data: (props) => <NumericalCell {...props} />,
				footerCell: (prop) => {
					const minDecimal = 0;
					const maxDecimal = 0;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "numberOfUnits",
			title: t("NumberOfUnits"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			headerClassName: "header-menu-numerical",
			cells: {
				data: (props) => <NumericalCell {...props} formatDecimal={0} />,
				footerCell: (prop) => {
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
							)}
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "averageWeight",
			title: t("AverageWeight"),
			columnMenu: ColumnMenu,
			filter: "numeric",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				footerCell: (prop) => {
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
							)}
						</td>
					);
				},
			},
			headerClassName: "header-menu-numerical",
			hidden: false,
		},
		{
			field: "quantity",
			title: t("Quantity"),
			headerCell: (props) => <NumericalHeader {...props} />,
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border `,
			cells: {
				data: (props) => <NumericalCell {...props} formatDecimal={0} />,
				footerCell: (prop) => {
					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
							)}
						</td>
					);
				},

				groupFooter: (props) => {
					const minDecimal = 0;
					const maxDecimal = 0;

					let data = props.dataItem.aggregates[props.field as any];

					return (
						<td className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},
			hidden: true,
		},
		{
			field: "buyerPrice",
			title: t("Price"),
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;
					// let data = calculateFieldStats(
					// 	props.dataItem.items,
					// 	props.field as any
					// );

					const data = props.dataItem.aggregates[props.field as any];

					return (
						<td className={CLASSNAME.TableNumeric}>
							<div
								style={{ marginTop: "20px" }}
								className="no-border td-bold"
							>{`Min: ${formatNorwegianNumber(data.min, minDecimal, maxDecimal)}
									 Avg: ${formatNorwegianNumber(
											data.average,
											minDecimal,
											maxDecimal,
										)} Max:  ${formatNorwegianNumber(
											data.max,
											minDecimal,
											maxDecimal,
										)}`}</div>
						</td>
					);
				},
			},
			hidden: false,
		},
		{
			field: "buyerValue",
			title: t("Value"),
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			//
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,

				footerCell: (prop) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					// const data = calculateFieldStats(
					// 	props.dataItem.items,
					// 	props.field as any
					// );
					const data = props.dataItem.aggregates[props.field as any];

					return (
						<td className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},

			hidden: false,
		},
		{
			field: "buyerGrossValue",
			title: t("BuyerGrossValue"),
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			groupable: true,
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,

				footerCell: (prop) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(props.data, prop.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
			},
			hidden: false,
		},
		{
			field: "",
			width: "40px",
		},
	];

	// Set a default width of "150px" for columns missing width
	return allColumns.map((col) => ({
		...col,
		width: col.minResizableWidth ? "" : col.width || "150px",
	}));
};

export const ColumnMenu = (props: GridColumnMenuProps) => {
	return (
		<div style={{ color: "black" }}>
			<GridColumnMenuFilter {...props} expanded={true} />
		</div>
	);
};

const ColumnMenuCheckboxFilter = (
	props: GridColumnMenuProps & { data: any[] },
) => {
	return (
		<div>
			<GridColumnMenuCheckboxFilter
				{...props}
				expanded={true}
				data={props.data}
			/>
		</div>
	);
};
